import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { FILMS } from "../data/films";
import { BRAND_LOGO } from "../data/brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black text-white/70">
      {/* Film-strip separator */}
      <div className="h-4 flex overflow-hidden border-b border-white/10">
        {Array.from({ length: 60 }).map((_, i) => (
          <div key={i} className="flex-1 flex items-center justify-center border-r border-white/5">
            <div className="w-1.5 h-1.5 bg-white/10 rounded-sm" />
          </div>
        ))}
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16 grid grid-cols-2 md:grid-cols-12 gap-10">
        <div className="col-span-2 md:col-span-4">
          <div className="flex items-center gap-3 mb-4">
            <img
              src={BRAND_LOGO}
              alt="Dhara Kala Movies"
              className="w-14 h-14 object-contain"
              style={{ filter: "brightness(0) saturate(100%) invert(69%) sepia(64%) saturate(431%) hue-rotate(2deg) brightness(94%) contrast(89%)" }}
            />
            <span className="font-serif-display text-white text-xl">Dhara Kala Movies</span>
          </div>
          <p className="font-serif-display italic text-white/60 max-w-md leading-relaxed">
            Stories rooted in culture. Cinema made for the world.
          </p>
          <div className="mt-6 flex gap-3">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a key={i} href="#" data-testid={`footer-social-${i}`}
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/60 hover:text-[color:var(--dk-gold)] hover:border-[color:var(--dk-gold)] transition-colors">
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)] mb-4">Navigate</p>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-projects-link" to="/films" className="hover:text-white">Projects</Link></li>
            <li><Link data-testid="footer-in-production-link" to="/in-production" className="hover:text-white">In Production</Link></li>
            <li><Link data-testid="footer-on-the-floor-link" to="/on-the-floor" className="hover:text-white">On the Floor</Link></li>
            <li><Link data-testid="footer-team-link" to="/team" className="hover:text-white">Team</Link></li>
            <li><Link data-testid="footer-gallery-link" to="/gallery" className="hover:text-white">Gallery</Link></li>
            <li><Link data-testid="footer-news-link" to="/news" className="hover:text-white">News & Festivals</Link></li>
            <li><Link data-testid="footer-contact-link" to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)] mb-4">Featured Projects</p>
          <ul className="space-y-2 text-sm">
            {FILMS.slice(0, 5).map((f) => (
              <li key={f.slug}>
                <Link to={`/films/${f.slug}`} className="hover:text-white">{f.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)] mb-4">Contact</p>
          <a data-testid="footer-email" href="mailto:dharakala@outlook.com" className="text-sm text-white eyebrow-link break-all">
            dharakala@outlook.com
          </a>
          <p className="mt-4 text-xs text-white/50 leading-relaxed">
            dharakalamovies.com<br />
            New Baneshwor, Kathmandu · Est. 2019
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-[10px] uppercase tracking-overline text-white/70">
          <span>© 2026 Dhara Kala Movies. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[color:var(--dk-gold)]">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[color:var(--dk-gold)]">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
